
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    section: 'protobuf',
    seed: '',
    pem: '',
    protobuf: '',
    loading: false
  }),

  computed: {
    categories() {
      return ['Protobuf', 'PEM', 'Key File']
    }
  },

  methods: {
    async upload(event: Event) {
      try {
        const input = event.target as HTMLInputElement
        const { files } = input

        if (!files || files.length === 0) {
          return
        }

        this.loading = true

        const file = files[0]

        console.log(file)

        const pem = await file.text()

        console.log(pem)

        const privateKey = await PrivateKey.fromProtobufPem(pem)
        this.$accessor.settings.setIpfsPrivateKey(privateKey.toProtobuf())
        this.$accessor.settings.save()

        location.reload()
      } catch (err: any) {
        alert('Error: ' + err.message)
      } finally {
        this.loading = false
      }
    },

    /*
    async importSeed() {
      try {
        this.loading = true

        const privateKey = await PrivateKey.fromMnemonic(this.seed)
        this.$accessor.settings.setIpfsPrivateKey(privateKey.toProtobuf())
        this.$accessor.settings.save()

        location.reload()
      } catch (err) {
        console.error(err.message, err)
        alert('Error: ' + err.message)
      } finally {
        this.loading = false
      }
    },
    */

    async importPem() {
      try {
        this.loading = true

        const privateKey = await PrivateKey.fromProtobufPem(this.pem)
        this.$accessor.settings.setIpfsPrivateKey(privateKey.toProtobuf())
        this.$accessor.settings.save()

        location.reload()
      } catch (err: any) {
        alert('Error: ' + err.message)
      } finally {
        this.loading = false
      }
    },

    async importProtobuf() {
      try {
        this.loading = true

        const privateKey = await PrivateKey.fromProtobuf(this.protobuf)
        this.$accessor.settings.setIpfsPrivateKey(privateKey.toProtobuf())
        this.$accessor.settings.save()

        location.reload()
      } catch (err: any) {
        alert('Error: ' + err.message)
      } finally {
        this.loading = false
      }
    }
  }
})
